/* global toastr */

import { wrapView, request } from '../smart_bps/lib/utils'
import { Link } from 'react-router-dom'
import { baseStateToProps } from '../smart_bps/lib/base_view'
import { AdminMenuView as CoreAdminIndexView } from '../smart_bps/admin/index_view'
import { store } from '../index'
import {AuthorizedDropDownMeny, UnauthorizedDropDownMenu} from "../lib/NavDropdownMenu";

class AdminIndexView extends CoreAdminIndexView {
  renderContent() {
    if (this.props.menu === undefined) {
      request({
          method: 'get',
          url: '/api/admin/menu',
          success: (data) => {
              store.dispatch({ type: 'admin_menu_data', data })
          },
          error: (data) => {
              toastr.error(data.detail || 'Ошибка загрузки меню')
          },
      })
      return null
    }

    let cards = []

    if (this.props.menu !== undefined) {
      this.props.menu.forEach((group) => {
        cards.push(
          <div className="col-md-6 col-lg-4 col-xl-3" key={group[0]}>
            <div className="card mb-3 sigur-admin-card">
              <div className="card-body p-3 d-flex flex-column">
                <h6 className="sigur-admin-group-title">{group[0]}</h6>
                <ul className="sigur-admin-list flex-grow-1">
                  {group[1].map((item) => (
                    <li key={item.model_name}>
                      <Link to={`/admin/${item.model_name}`} className="sigur-admin-link">
                        <span className="sigur-admin-link-text">{item.title}</span>
                        <i className="ti ti-chevron-right sigur-admin-link-icon" />
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        )
      })
    }
    return <div className="row sigur-admin-index">{cards}</div>
  }

  renderTopPanelRightItems() {
    if (this.authorized) {
      return (
        <AuthorizedDropDownMeny
          userTitle={this.user_title}
          onLogout={this.logout}
        />
      )
    }
    return <UnauthorizedDropDownMenu/>
  }
}

function adminStateToProps(state) {
    const props = baseStateToProps(state)
    props.menu = state.admin.menu
    return props
}

export default wrapView(AdminIndexView, adminStateToProps)
